const textCon = {
    // menu
    home: {
        zh: '主页',
        en: 'home',
        tzh: '主頁',
    },
    about: {
        zh: '关于我们',
        en: 'about',
        tzh: '關於我們',
    },
    contact: {
        zh: '联系我们',
        en: 'contact',
        tzh: '聯繫我們',
    },
    
    jakcmall: {
        zh: 'JAKC 商场',
        en: 'JAKC mall',
        tzh: 'JAKC 商場',
    },
    office: {
        zh: '办公',
        en: 'office',
        tzh: '辦公',
    },
    residence: {
        zh: '公寓',
        en: 'residence',
        tzh: '公寓',
    },
    hotel: {
        zh: '酒店',
        en: 'hotel',
        tzh: '酒店',
    },
    address: {
        zh: '位置',
        en: 'location',
        tzh: '位置',
    },


    // footer
    footerAdd: {
        zh: '© 2024 静安嘉里中心',
        en: '© 2024 Jing An Kerry Centre',
        tzh: '© 2024 靜安嘉里中心',
    },
    footerPri: {
        zh: '隐私政策',
        en: 'Privacy Policy',
        tzh: '隱私政策',
    },
    footerR1: {
        zh: '沪ICP备 19003416号-3',
        en: '沪ICP备 19003416号-3',
        tzh: '沪ICP备 19003416号-3',
    },
    footerR2: {
        zh: '沪公网安备 31010602006468号',
        en: '沪公网安备 31010602006468号',
        tzh: '沪公网安备 31010602006468号',
    },
    
    // cookie
    cookieTitle: {
        zh: 'Cookies 使用提示',
        en: 'Cookies',
        tzh: 'Cookies 使用提示',
    },
    cookieLine1: {
        zh: '为提升您的浏览体验，本网站可能通过Cookie收集设备信息',
        en: 'To enhance your browsing experience, this website may collect device',
        tzh: '為提升您的瀏覽體驗，本網站可能透過Cookie收集裝置資訊',
    },
    cookieLine2: {
        zh: '（如浏览器类型）和您的IP地址信息等。所有数据均匿名处理，',
        en: 'information (such as browser type) and your IP address through',
        tzh: '（如瀏覽器類型）及您的IP位址等資料。所有數據均以匿名方式處理，',
    },
    cookieLine3: {
        zh: '不会关联个人身份。如不同意，请“关闭”。',
        en: 'cookies. All data is processed anonymously and is not linked to',
        tzh: '不會關聯個人身分。如不同意，請點選「關閉」。',
    },
    cookieLine4: {
        zh: '',
        en: 'personal identity. If you do not agree, please select “Close.”',
        tzh: '',
    },
    cookieAgree: {
        zh: '同意',
        en: 'agree',
        tzh: '同意',
    },
    cookieClose: {
        zh: '关闭',
        en: 'close',
        tzh: '關閉',
    },

    // Cookie Banner 底部提示条
    cookieBannerText: {
        zh: '我们使用 Cookie 以允许我们网站的正常工作、个性化设计内容和广告、提供社交媒体功能并分析流量。我们还同社交媒体、广告和分析合作伙伴分享有关您使用我们网站的信息。',
        en: 'We use cookies to allow our site to work properly, personalize content and ads, provide social media features, and analyze traffic. We also share information about your use of our site with social media, advertising and analytics partners.',
        tzh: '我們使用 Cookie 以允許我們網站的正常工作、個性化設計內容和廣告、提供社交媒體功能並分析流量。我們還同社交媒體、廣告和分析合作夥伴分享有關您使用我們網站的資訊。'
    },
    cookiePrivacyLink: {
        zh: '隐私政策',
        en: 'Privacy Policy',
        tzh: '隱私政策'
    },
    cookieSettingsBtn: {
        zh: 'Cookie 设置',
        en: 'Cookie Settings',
        tzh: 'Cookie 設定'
    },

    // Cookie Consent Center - 隐私偏好中心
    cookieCenterTitle: {
        zh: '隐私偏好中心',
        en: 'Privacy Preference Center',
        tzh: '隱私偏好中心',
    },
    cookieCenterDesc1: {
        zh: '您访问任何网站时,网站都可能在您的浏览器上存储或检索信息,大多数是以 Cookie 的形式进行。此信息可能与您、您的偏好、您的设备相关,或者该信息被用于使网站按照您期望的方式工作。这些信息通常不会直接识别您,但它可为您提供更多个性化的 Web 体验。您可以选择不允许使用某些类型的 Cookie。单击不同类别标题以了解更多信息并更改默认设置。但是,您应该知道,阻止某些类型的 Cookie 可能会影响您的网站体验和我们能够提供的服务。',
        en: 'When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.',
        tzh: '您訪問任何網站時,網站都可能會在您的瀏覽器上存儲或檢索資訊,大多數是以 Cookie 的形式進行。此資訊可能與您、您的偏好、您的設備相關,或者該資訊被用於使網站按照您期望的方式工作。這些資訊通常不會直接識別您,但它可為您提供更多個人化的 Web 體驗。您可以選擇不允許使用某些類型的 Cookie。單擊不同類別標題以瞭解更多資訊並更改預設設定。但是,您應該知道,阻止某些類型的 Cookie 可能會影響您的網站體驗和我們能夠提供的服務。',
    },
    cookieCenterDesc2: {
        zh: '',
        en: '',
        tzh: '',
    },
    cookieMoreInfo: {
        zh: '有关 Cookie 同意的更多信息',
        en: 'More information about cookie consent',
        tzh: '有關 Cookie 同意的更多資訊',
    },
    cookieManageTitle: {
        zh: '管理许可偏好',
        en: 'Manage Consent Preferences',
        tzh: '管理許可偏好',
    },
    cookieNecessary: {
        zh: '绝对必要的 Cookie',
        en: 'Strictly Necessary Cookies',
        tzh: '絕對必要的 Cookie',
    },
    cookieAlwaysActive: {
        zh: '始终处于活动状态',
        en: 'Always Active',
        tzh: '始終處於活動狀態',
    },
    cookieNecessaryDesc: {
        zh: '这些 Cookie 对于网站的正常运行是必需的,无法禁用。它们通常在响应您的操作时设置,例如设置隐私偏好、登录或填写表单。您可以将浏览器设置为阻止或提醒您这些 Cookie,但网站的某些部分可能无法正常工作。',
        en: 'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work.',
        tzh: '這些 Cookie 對於網站的正常運行是必需的,無法停用。它們通常在回應您的操作時設置,例如設置隱私偏好、登錄或填寫表單。您可以將瀏覽器設置為阻止或提醒您這些 Cookie,但網站的某些部分可能無法正常工作。',
    },
    cookiePerformance: {
        zh: '性能 Cookie',
        en: 'Performance Cookies',
        tzh: '效能 Cookie',
    },
    cookiePerformanceDesc: {
        zh: '这些 Cookie 允许我们统计访问次数和流量来源,以便衡量和改进我们网站的性能。它们帮助我们了解哪些页面最受欢迎、哪些页面最不受欢迎,并了解访客如何在网站上移动。所有由这些 Cookie 收集的信息都是汇总的,因此是匿名的。如果您不允许这些 Cookie,我们将不知道您何时访问过我们的网站。',
        en: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site.',
        tzh: '這些 Cookie 允許我們統計訪問次數和流量來源,以便衡量和改進我們網站的性能。它們幫助我們瞭解哪些頁面最受歡迎、哪些頁面最不受歡迎,並瞭解訪客如何在網站上移動。所有由這些 Cookie 收集的資訊都是匯總的,因此是匿名的。如果您不允許這些 Cookie,我們將不知道您何時訪問過我們的網站。',
    },
    cookieFunctional: {
        zh: '功能 Cookie',
        en: 'Functional Cookies',
        tzh: '功能性 Cookie',
    },
    cookieFunctionalDesc: {
        zh: '这些 Cookie 使网站能够提供增强的功能和个性化。它们可能由我们或我们添加到页面上的第三方服务提供商设置。如果您不允许这些 Cookie,则其中一些或全部服务可能无法正常运行。',
        en: 'These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.',
        tzh: '這些 Cookie 使網站能夠提供增強的功能和個人化。它們可能由我們或我們添加到頁面上的第三方服務提供商設置。如果您不允許這些 Cookie,則其中一些或全部服務可能無法正常運行。',
    },
    cookieTargeting: {
        zh: '定向 Cookie',
        en: 'Targeting Cookies',
        tzh: '目標 Cookie',
    },
    cookieTargetingDesc: {
        zh: '这些 Cookie 可能通过我们的网站由我们的广告合作伙伴设置。它们可用于通过这些公司建立您的兴趣档案,并在其他网站上向您展示相关广告。它们不直接存储个人信息,而是基于唯一标识您的浏览器和互联网设备。如果您不允许这些 Cookie,您将体验到较少的定向广告。',
        en: 'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.',
        tzh: '這些 Cookie 可能通過我們的網站由我們的廣告合作夥伴設置。它們可用於通過這些公司建立您的興趣檔案,並在其他網站上向您展示相關廣告。它們不直接存儲個人資訊,而是基於唯一標識您的瀏覽器和互聯網設備。如果您不允許這些 Cookie,您將體驗到較少的定向廣告。',
    },
    cookieRejectAll: {
        zh: '全部拒绝',
        en: 'Reject All',
        tzh: '全部拒絕',
    },
    cookieConfirm: {
        zh: '确认我的选择',
        en: 'Confirm My Choices',
        tzh: '確認我的選擇',
    }
};

export default textCon;